<mat-list-item class="switch-color-scheme" (click)="toggleColorScheme()">
  <mat-icon matListItemIcon>{{ icon() }}</mat-icon>
  <p matListItemTitle>{{ text() | translate }}</p>
</mat-list-item>
